import type { ProductCostView } from '@wms/domain';
import { useEffect, useState } from 'react';
import { api, errorMessage } from '../../api';
import { COST_THOUSANDS_TEXT, costFieldText, costInput, sameCost } from '../../profit';
import { useToast } from '../../ui';

/** A unit cost typed in place: saved on Enter or on leaving the field when it changed. */
export function CostField(props: { cost: ProductCostView; canEdit: boolean; onSaved: (next: ProductCostView) => void; id?: string }) {
  const toast = useToast();
  const [text, setText] = useState(costFieldText(props.cost.unitCost));
  const [busy, setBusy] = useState(false);
  useEffect(() => setText(costFieldText(props.cost.unitCost)), [props.cost.unitCost]);
  const save = async () => {
    const typed = costInput(text);
    if (!typed.ok) {
      toast(typed.thousands ? COST_THOUSANDS_TEXT : 'Birim maliyeti 12,50 biçiminde yazın', 'bad');
      setText(costFieldText(props.cost.unitCost));
      return;
    }
    if (sameCost(typed.value, props.cost.unitCost)) return;
    setBusy(true);
    try {
      const next = await api<ProductCostView>('PUT', `/api/profit/costs/${props.cost.productId}`, { unitCost: typed.value });
      toast(typed.value === null ? `${props.cost.sku}: maliyet silindi` : `${props.cost.sku}: maliyet kaydedildi`, 'ok');
      props.onSaved(next);
    } catch (e) {
      toast(errorMessage(e), 'bad');
      setText(costFieldText(props.cost.unitCost));
    } finally {
      setBusy(false);
    }
  };
  return (
    <input
      id={props.id}
      className="input num"
      style={{ maxWidth: 140 }}
      inputMode="decimal"
      placeholder="Girilmedi"
      value={text}
      disabled={!props.canEdit || busy}
      onChange={(e) => setText(e.target.value)}
      onBlur={() => void save()}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
      }}
      aria-label={`${props.cost.sku} birim maliyeti (KDV hariç)`}
    />
  );
}
